import { Component, ElementRef, Renderer2, ViewChild, inject } from '@angular/core';

import { AbstractSchedulerComponent } from '../../abstract-scheduler.component';

@Component({
  selector: 'cam-calendar-scheduler-view',
  templateUrl: './view.component.html',
  styleUrl: './view.component.scss',
})
export class CamCalendarSchedulerViewComponent extends AbstractSchedulerComponent {
  @ViewChild('scheduler', { static: true })
  scheduler!: ElementRef;

  private _renderer = inject(Renderer2);

  ngAfterViewInit() {
    this._registerSubscription(
      this.getIsReady$().subscribe({
        next: () => {
          if (this._scheduler.component) {
            this._renderer.appendChild(this.scheduler.nativeElement, this._scheduler.component.nativeElement);
          }
        },
      })
    );
  }
}
